import React, { Component } from 'react';

export default class DatePickerInput extends Component {
	input = null;

	focus = () => {
		this.input.focus();
	};

	render() {
		return (
			<div className="input-group">
				<input {...this.props} ref={el => (this.input = el)} />
			</div>
		);
	}
}



// WEBPACK FOOTER //
// ./src/ui/components/DatePicker/DatePickerInput.js